<script lang="ts" setup>
import { ref } from "vue";
import type {
  TripMonitorOrder,
  TripMonitorRoute,
  TripMonitorTravelOrder as TripMonitorTravelOrderType,
} from "@/api/trips/dto/trip-monitor";
import type { TripUpdate } from "@/api/trips/dto/update";
import TripMonitorTravelOrder from "@/views/trips/monitor/components/TripMonitorTravelOrder.vue";
import { API } from "@/api/api";
import { useSnackbarStore } from "@/store/snackbar.store";

const api = new API();

defineModel<boolean>("showCreateDialog", { default: false });
defineModel<boolean>("showInfoDialog", { default: false });
defineModel<boolean>("showIntervalDialog", { default: false });

const props = defineProps<{
  route: TripMonitorRoute;
  tripId: number;
  orders: TripMonitorOrder[];
}>();

const emits = defineEmits<{
  (
    e: "setDialogsData",
    route: TripMonitorRoute,
    travelOrder: TripMonitorTravelOrderType | null,
    tripId: number,
    update: TripUpdate | null,
  ): void;
  (e: "update:showCreateDialog", value: boolean): void;
  (e: "update:showInfoDialog", value: boolean): void;
  (e: "update:showIntervalDialog", value: boolean): void;
}>();

const { showSnackbarError } = useSnackbarStore();

const update = ref<TripUpdate | null>(null);

const showCreateUpdateDialog = (travelOrder: TripMonitorTravelOrderType) => {
  emits("setDialogsData", props.route, travelOrder, props.tripId, null);
  emits("update:showCreateDialog", true);
};

async function viewUpdate(updateId: number) {
  try {
    const response = await api.events.loadBrokerUpdate(props.route.id, updateId);

    if (response?.data) {
      update.value = response.data;
      emits("setDialogsData", props.route, null, props.tripId, update.value);
      emits("update:showInfoDialog", true);
    }
  } catch (error) {
    showSnackbarError("Could not load broker update");
  }
}

function openIntervalDialog(travelOrder: TripMonitorTravelOrderType) {
  emits("setDialogsData", props.route, travelOrder, props.tripId, null);
  emits("update:showIntervalDialog", true);
}
</script>

<template>
  <div class="d-flex row-gap-2 flex-column">
    <div v-for="(item, index) of route.travelOrders" :key="item.id" class="d-flex align-center">
      <trip-monitor-travel-order
        :index="index"
        :orders="orders"
        :route="route"
        :travel-order="item"
        :trip-id="tripId"
        @show-create-dialog="showCreateUpdateDialog"
        @view-update="viewUpdate"
        @open-interval-dialog="openIntervalDialog"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
